const ArrowSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M2.98423 5.16491C2.92854 5.11228 2.86303 5.07114 2.79143 5.04383C2.71984 5.01652 2.64357 5.00358 2.56698 5.00575C2.49039 5.00791 2.41497 5.02515 2.34504 5.05646C2.2751 5.08777 2.21202 5.13255 2.1594 5.18824C2.10677 5.24393 2.06563 5.30945 2.03832 5.38104C2.01101 5.45263 1.99807 5.5289 2.00023 5.60549C2.0024 5.68209 2.01963 5.7575 2.05094 5.82744C2.08226 5.89737 2.12704 5.96045 2.18273 6.01308L7.43273 10.9714C7.54104 11.0738 7.68443 11.1309 7.83348 11.1309C7.98253 11.1309 8.12592 11.0738 8.23423 10.9714L13.4848 6.01308C13.5417 5.9608 13.5877 5.89773 13.62 5.82754C13.6523 5.75735 13.6704 5.68143 13.6731 5.6042C13.6759 5.52697 13.6633 5.44997 13.636 5.37766C13.6087 5.30535 13.5674 5.23918 13.5143 5.18299C13.4612 5.12681 13.3976 5.08172 13.3269 5.05036C13.2563 5.019 13.1801 5.00198 13.1029 5.0003C13.0256 4.99861 12.9488 5.0123 12.8769 5.04056C12.8049 5.06882 12.7393 5.11109 12.6839 5.16491L7.83348 9.74524L2.98423 5.16491Z"
        fill="#333333"
        stroke="#333333"
        strokeWidth="0.4"
      />
    </svg>
  );
};

export default ArrowSvg;
